goog.provide('el8.appchart.refpanel.allergies');

goog.require('el8.appchart.dialog.addEditAllergy');
goog.require('el8.appchart.dialog.allergyHx');
goog.require('el8.appchart.metrics');
goog.require('el8.appchart.mgr.notes');
goog.require('el8.model.base');
goog.require('el8.ptdata.ptAllergies');
goog.require('el8.template.appchart.refpanel.allergies');
goog.require('el8.uiwidget.collapsible');
goog.require('el8.appchart.refpanel.RefPanelSection');

el8.appchart.refpanel.allergies = (function() {

    var reportOnFirstLoad = el8.appchart.metrics.getChartLoadCallback('allergies');

    var renderFn = function() {
        $('#allergy-section').removeClass('el8Loading');

        // Cleanup tooltips before rerender allergies
        el8.service.tooltip.destroy($('.user-created-allergy-warning'));

        $('.allergy-buttons', $('#allergy-section')).html(
            el8.template.appchart.refpanel.allergies.addNewTrigger({
                isNotDocumented: el8.ptdata.ptAllergies.isNotDocumented()
            })
        );

        $('#allergy-summary').html(
            el8.template.appchart.refpanel.allergies.allergyList({
                actives: el8.ptdata.ptAllergies.getAllActive().map(el8.model.toSoyMapFn),
                inactives: el8.ptdata.ptAllergies.getAllInactive().map(el8.model.toSoyMapFn),
                isDocumentedAsNone: el8.ptdata.ptAllergies.isDocumentedAsNone(),
                hasUserCreatedAllergies: el8.ptdata.ptAllergies.hasUserCreatedAllergies()
            })
        );
        // Initialize allergies tooltips
        el8.service.tooltip.create({
            anchor: $('.user-created-allergy-warning'),
            text: "Elation cannot check meds against this allergy because it is not from the database. To fix this, edit and re-enter the name making sure to select from the database suggestions.",
            placement: "bottom",
            theme: ['250', 'dark']
        });

        $('.allergy-values').text(el8.ptdata.ptAllergies.getSummary());
        if (el8.ptdata.ptAllergies.isDocumentedAsNone()) {
            $('#allergy-summary-header').removeClass('alert');
        } else {
            $('#allergy-summary-header').addClass('alert');
        }

        $('#allergy-indicator').html(
            el8.template.appchart.refpanel.allergies.indicator({
                isDocumentedAsNone: el8.ptdata.ptAllergies.isDocumentedAsNone(),
                actives: el8.ptdata.ptAllergies.getAllActive()
            })
        );

        reportOnFirstLoad();
    };

    var that = new el8.appchart.refpanel.RefPanelSection({

        initFn: function() {
            var container = $('#allergy-section');
            that.addContainer(container);

            var indicator = $('#allergy-indicator');

            el8.uiwidget.collapsible({
                container: container,
                triggerElt: $('#allergy-summary-header'),
                statusElt: $('#allergy-summary-status')
            });

            container.on('click', '.add-allergy-trigger',  function(e) {
                el8.appchart.dialog.addEditAllergy.show();

            }).on('click', '.document-none-trigger',  function(e) {
                el8.ptdata.ptAllergies.saveAsDocumented();

            }).on('click', '.edit-text-trigger',  function(e) {
                var itemId = $(this).data('id');
                var ptAllergy = el8.ptdata.ptAllergies.getById(itemId);
                if (ptAllergy) {
                    el8.appchart.dialog.addEditAllergy.show({'ptAllergy': ptAllergy});
                    return false;
                }
            }).on('click', '.more-actions-trigger',  function(e) {
                var itemId = $(this).data('id');
                var ptAllergy = itemId ? el8.ptdata.ptAllergies.getById(itemId) : null;
                var menu = el8.appchart.actions.allergies({ item: ptAllergy });
                el8.appchart.refpanel.actionsMenu.display(
                    $(this),
                    null,
                    {top: 17, left: 5},
                    menu
                );
                return false;
            });

            // Add event to allergy label
            indicator.on('click', '.allergy-label',  function(e) {
                var refBoard = $('#refBoardContainer'); // LHS scrollable container
                var allergyHeader = $('#allergy-summary-header');
                var allergyHeaderTop = allergyHeader.position().top; // get top positioning within refBoard
                // Scroll to allergy section
                refBoard.scrollTo(allergyHeaderTop);
                // Expand section
                allergyHeader.trigger('el8_expand');

                return false;
            });

            $('#refBoardContainer').on('click', '.allergy-list-actions-trigger',  function() {
                var menu = [
                    {
                        actionText: 'Add Allergy',
                        actionFn: function() { el8.appchart.dialog.addEditAllergy.show(); }
                    },
                    {
                        actionText: 'Export Allergies to Note',
                        actionFn: function() { el8.appchart.mgr.notes.referenceAllergies(); }
                    },
                    {
                        actionText: 'View Hx',
                        actionFn: function() { el8.appchart.dialog.allergyHx.show(); }
                    }
                ];

                el8.appchart.refpanel.actionsMenu.display(
                    $(this), null,
                    {'top': 17, 'left': 20},
                    menu
                );
                return false;
            });

        },
        dataRenderers: [
            {
                entitySet: el8.ptdata.ptAllergies,
                events: [{
                    eventName: 'all',
                    fn: renderFn
                }],
                renderFn: renderFn
            }
        ]
    });
    return that;

})();
